import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";
import { useNavigationBar } from "../../../context/NavigationContext";
import { GuideArtifactItems, SKGuideArtifact, ContentState } from "../../../models/SKArtifact";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import AddLocatioinSeacrh from "./container/components/AddLocatioinSeacrh";
import { isEditable } from "@testing-library/user-event/dist/utils";

export default function AddGuide() {
  const { contentData, artifactId, updateContentData, loading, saveData, isEditable } = useContext(CreateArtifactContext);
  const { setNavProps } = useNavigationBar();
  const navigate = useNavigate();
  const [editable, setEditable] = useState<boolean>(true);
  const [isValidForm, setIsValidForm] = useState(false);
  const [guideData, setGuideData] = useState<GuideArtifactItems[]>([]);

  const schema = Yup.object().shape({
    guideItems: Yup.array()
      .of(
        Yup.object().shape({
          id: Yup.string().required(),
          location: Yup.object({
            latitude: Yup.number().required("Latitude is required"),
            longitude: Yup.number().required("Longitude is required"),
            title: Yup.string().required("Title is required"),
            address: Yup.string().required("Address is required"),
            url: Yup.string().notRequired(),
          }).required(),
        })
      )
      .required()
      .min(1, "GuideItems must contain at least 1 items"),
  });

  useEffect(() => {
    const validate = async () => {
      try {
        await schema.validate(contentData, { abortEarly: false });
        setIsValidForm(true);
      } catch (err) {
        setIsValidForm(false);
      }
    };
    validate();
  }, [contentData, schema]);

  useEffect(() => {
    const validate = async () => {
      try {
        await schema.validate(contentData, { abortEarly: false });
        setIsValidForm(true);
      } catch (err) {
        setIsValidForm(false);
      }
    };
    validate();
  }, [contentData]);

  useEffect(() => {
    if (contentData.status === ContentState.DRAFT) {
      setEditable(true);
    } else {
      setEditable(false);
    }
  }, [contentData]);

  useEffect(() => {
    if ((contentData as SKGuideArtifact).guideItems != null) {
      const enableLink = (contentData as SKGuideArtifact).guideItems.length === 1 && (contentData as SKGuideArtifact).guideItems.length > 0;

      setNavProps(prev => ({
        ...prev,
        backArrow: false,
        buttonTitle: "Done",
        title: " Add Guide",
        getActionItems: undefined,
        enableLink: isEditable ? isValidForm : false,
        onNext: isEditable ? submit : undefined,
        onClose: () => navigate(-1),
        onEdit: undefined,
      }));
    }
  }, [setNavProps, (contentData as SKGuideArtifact).guideItems, isValidForm, isEditable]);

  /*  useEffect(() => {
    setNavProps((prev) => ({
      ...prev,
      backArrow: false,
      buttonTitle: "Done",
      enableLink: contentData.status === State.review ? false : isValidForm,
      onNext: submit,
    }));
  }, [setNavProps, isValidForm]); */

  useEffect(() => {
    if ((contentData as SKGuideArtifact).guideItems != null) {
      setGuideData((contentData as SKGuideArtifact).guideItems);
    }
  }, []);

  const submit = async () => {
    await saveData();
    window.history.back();
  };

  function handleRemoveItem(listId: any): void {
    const updatedItems = guideData.filter(item => item.id !== listId);
    updateContentData({ guideItems: updatedItems });
    setGuideData(updatedItems);
  }

  function removeItemUrl(listId: any): void {
    const updatedItems = guideData.map(item => {
      if (item.id === listId) {
        return {
          ...item,
          location: {
            ...item.location,
            url: "",
          },
        };
      }
      return item;
    });
    updateContentData({ guideItems: updatedItems });
    setGuideData(updatedItems);
  }
  return (
    <>
      <div className="flex flex-col gap-[30px] mt-[12px]">
        {isEditable && (
          <div className="flex flex-col">
            <AddLocatioinSeacrh
              name={"addplace"}
              title={"Add Place"}
              note={"Search for the place or location."}
              placeholder={"Search Place"}
              index={1}
              isVisible={true}
              value={""}
              onChange={(address, title, url, loc) => {
                const location = url
                  ? {
                      latitude: loc.lat,
                      longitude: loc.lng,
                      title,
                      address,
                      url,
                    }
                  : {
                      latitude: loc.lat,
                      longitude: loc.lng,
                      title,
                      address,
                    };

                const newItem: GuideArtifactItems = {
                  id: crypto.randomUUID(),
                  location,
                };
                const updatedItems = [...guideData, newItem];
                updateContentData({ guideItems: updatedItems });
                setGuideData(updatedItems);
              }}
            />
          </div>
        )}
        <div id="showcase_id" className="relative w-full min-w-[200px]">
          <div>
            <div className="flex items-center">
              <span>{isEditable && <span className="content_count">2</span>}</span>
              <span className="content_title">Places Added</span>
            </div>
            <div className="notes-class-content">Places your add show up here, you can add description to each place.</div>
            {guideData.length >= 1 && (
              <table className="flex flex-col">
                <tbody className="flex flex-col gap-[15px]">
                  {guideData.map((item, index) => (
                    <tr key={index} className="location_card">
                      <td className="relative">
                        <div className="flex items-center w-[460px]">
                          <div className="content_count">{index + 1}</div>
                          <span className="location_list_title">{item.location?.title}</span>
                          <span className="ml-auto mr-[10px]">
                            {isEditable && (
                              <div className="items-center content-center justify-center w-5 h-5 align-middle shadow-md top-2 rounded-3xl bg-slate-600">
                                <button className="top-0 left-0 right-0 content-center w-5 h-5 text-white" onClick={() => handleRemoveItem(item.id)}>
                                  ×
                                </button>
                              </div>
                            )}
                          </span>
                        </div>
                        <div className="location_list_sub_title">{item.location?.address}</div>
                        {item.location?.url?.trim() && (
                          <div className="flex flex-row items-center gap-3 location_list_url">
                            <a href={item.location.url} target="_blank" rel="noopener noreferrer" className="location_list_url">
                              {item.location?.url
                                ? item.location.url?.length > 100
                                  ? `${item.location.url.slice(0, 100)}...`
                                  : item.location.url
                                : ""}
                            </a>
                            <div className="content-center w-4 h-4 align-middle shadow-md top-1 rounded-3xl bg-slate-600 max-w-[486px] mr-[5px] mt-[5px]">
                              <button
                                id="removeItem"
                                className="top-0 left-0 right-0 content-center w-4 h-4 text-white "
                                onClick={e => {
                                  e.stopPropagation();
                                  removeItemUrl(item.id);
                                }}
                              >
                                ×
                              </button>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
